



































import { Component, Vue, Watch } from 'vue-property-decorator';
import checkout from '@/store/modules/checkout';
import user from '@/store/modules/user';
import { QuoteAddress, Country, RequestInvoicePayload } from '@/store/models';
import AddressList from '@/components/Address/List.vue';
import AddressForm from '@/components/Address/Form.vue';
import AddressSummary from '@/components/Address/Summary.vue';
import { normalizeQuoteAddress, compareAddress, copyAddressData } from '@/commons/addressNormalizer';
import RequestInvoice from '@/components/Checkout/InvoiceStep/RequestInvoice.vue';
import { findRegions } from '@/commons/regionFinder';
import store from '@/store';
import CmsBlock from '@/components/Cms/Block.vue';
import { scrollTo, scrollToInput } from '@/commons/scrollto';
import cart from '@/store/modules/cart';
import gtmhelpers from '@/commons/gtmhelpers';

@Component({
  components: {
    AddressList,
    RequestInvoice,
    AddressForm,
    CmsBlock,
    AddressSummary,
  },
  provide() {
    return {
      $validator: this.$validator,
    };
  },
})
export default class InvoiceStep extends Vue {
  private loading: boolean = false;

  @Watch('address.country_id')
  private onCountryIdChange(val: any, oldVal: any) {
    if (val && oldVal && val !== oldVal) {
      this.address.region = '';
      this.address.region_id = 0;
    }
  }

  get hasPlaceError(): boolean {
    return checkout.hasPlaceErrorByCode('invoice_address');
  }

  get address(): QuoteAddress {
    return checkout.billingAddress;
  }

  get hasAddresses(): boolean {
    return user.customer.addresses.length > 0;
  }

  get isLogged(): boolean {
    return user.isLoggedin;
  }

  get coutryRegions() {
    return findRegions(this.address.country_id);
  }

  get countries(): Country[] {
    return store.state.countryData.countries;
  }

  get isRequestInvoiceEnabled(): boolean {
    return store.state.options.request_invoice_enabled;
  }

  get fulfilled(): boolean {
    return checkout.stepByName('invoice').fulfilled;
  }

  get unlocked(): boolean {
    return checkout.stepByName('invoice').unlocked;
  }

  get saveText() {
    return store.state.options.carrier.multicarrier ? 'Further' : 'Confirm';
  }

  private editStep() {
    user.setEditMode({mode: '', selectedId: undefined});
    checkout.stepByName('invoice').fulfilled = false;
  }

  private async save(address: QuoteAddress) {
    let hasErrors = false;
    this.loading = true;
    const valid = await this.$validator.validateAll();
    if (!valid) {
      hasErrors = true;
    }

    const isMulticarrier = store.state.options.carrier.multicarrier;

    this.loading = false;
    if (!hasErrors) {

      user.copySelectedAddressToQuoteAddress('billing');

      if (isMulticarrier) {
        await checkout.estimateShippingSimple(address);
        checkout.setSelectedShipment('');
        checkout.resetStep('shipping');
      }

      if (checkout.isInvoiceRequested && checkout.invoiceRequestData) {
        const requestInvoice = checkout.invoiceRequestData;
        const payload: RequestInvoicePayload = {
          requestInvoice: {
            tdy_request_invoice: requestInvoice.enabled,
            tdy_request_invoice_vat_id: requestInvoice.cfpiva,
            tdy_request_invoice_gender: requestInvoice.gender,
            tdy_request_invoice_dob: requestInvoice.dateofbirth,
            tdy_request_invoice_pob: requestInvoice.placeofbirth,
          },
        };
        try {
          await checkout.assignRequestInvoice(payload);
        } catch (e) {
          const ex: any = e;
          this.$toast.err(ex.message);
          return;
        }
      }

      if (user.editAddressMode !== '') {
        try {
          await user.saveUserAddress({
            address: user.editAddress,
            addressType: 'billing',
            mode: user.editAddressMode,
            editingAddressId: checkout.selectedAddressId.billing,
          });
        } catch (e) {
          const ex: any = e;
          this.$toast.err(ex.message);
          return;
        }
      }
      if (this.isLogged && !this.hasAddresses) {
        user.saveUserAddress({
          address,
          addressType: 'billing',
          mode: 'new',
        }).catch((e) => {
          this.$toast.err(e.message);
        });
      }
      checkout.assignBillingAddress(normalizeQuoteAddress(address, true));

      if (!checkout.isShippingAddressFulfilled) {
        copyAddressData(address, checkout.shippingAddress);
      }
      gtmhelpers.trackBillingInfo(
          gtmhelpers.convertProductsData(
              cart.cart.items),
              cart.totals.grand_total,
              cart.totals.quote_currency_code,
              checkout.coupon.coupon
      );

        scrollTo('.invoice-step', 30);

      checkout.resetPlaceErrors('invoice_address');
      checkout.goingToStep({fromStep: 'invoice', toStep: 'shipping'});
      if (cart.cart.is_virtual) {
        checkout.goingToStep({fromStep: 'shipping', toStep: 'payment'});
      }
    } else {
      if (this.$validator.errors.items.length > 0) {
        scrollToInput(this.$validator.errors.items[0].field);
      }
    }
  }
}
